import { render, staticRenderFns } from "./MarketUpdates.vue?vue&type=template&id=687f810a"
import script from "./MarketUpdates.vue?vue&type=script&lang=js"
export * from "./MarketUpdates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports